//#region Libraries
import styled from "styled-components";
import { QUARTER_HEIGHT_CELL_BODY } from "../../utils/constants";
//#endregion

export const Activity = styled.div`
    position: relative;
    z-index: ${({ zIndex }) => zIndex ? zIndex : 1};
    padding: 0 1px;
`;
export const TextLine = styled.span.attrs({
    className: "ellipsis"
})`
    display: inline-block;
    width: 100%;
`;
export const Wrapper = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: ${({ heightRatio = 4 }) => heightRatio > 4 ? "center" : "flex-start"};
    gap: 5px;
    border-radius: 4px;
    background-color: var(--light-blue-6);
    padding: 15px 10px;
    margin: 1px;
    min-width: 148px;
    width: 100%;
    height: calc(${QUARTER_HEIGHT_CELL_BODY}px * ${({ heightRatio = 4 }) => heightRatio});
    transition: 0.35s;
    position: relative;
    user-select: none;
    cursor: pointer;
    &.finalized {
        flex-direction: ${({ heightRatio = 4 }) => heightRatio < 4 ? "row" : "column"};
    }
    &:hover { filter: brightness(90%); }
    & * { color: var(--light-1); }
    & > header {
        width: 70%;
        & h5 {
            font-weight: 900;
            font-size: 13px;
            margin: 0;
            margin-bottom: 3px;
            width: 125px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        & span { 
            font-size: 12px; 
            width: 125px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            display: block;
        }
    }
    & .icon {
        display: block;
        position: absolute;
        bottom: 5px;
        right: 5px;
        width: 20px;
    }
    &.presential {
        background-color: var(--green-3); 
        &.finalized:not(.past) {
            background-color: var(--light-1);
            border: 1px solid var(--green-3);
            & > header * {
                color: var(--green-3);
            }
            & .info-icon, & .icon {
                & svg, & path {
                    fill: var(--green-3);
                }
            }
        }
    }
    &:not(.past).available {
        background-color: var(--light-1);
        border: 1px solid var(--light-blue-6);
        & > header * {
            color: var(--light-blue-6);
        }
        &.presential { 
            border-color: var(--green-3); 
            & > header * {
                color: var(--green-3);
            }
        }
    }
    &.inactivity {
        background-color: var(--gray-1);
        & h5 {
            color: var(--gray-2);
        }
    }
    &.past {
        border: 1px solid var(--light-gray-3);
        background-color: var(--light-1);
        pointer-events: none;
        & > header * {
            color: var(--light-gray-3);
        }
    }
    &.on-use {
        & .info-icon path, .icon path {
            fill: var(--light-3);
        }
    }
    &.less-than-one-hour {
        padding: 2px 10px;
        padding-right: 0;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        & .icon {
            right: 20px;
            bottom: 0;
        }
        & .info-icon {
            align-self: flex-end;
            transform: translateX(-2.5px);
            & path { fill: var(--light-1); }
        }
        & h5 { margin-bottom: 0px; }
    }
`;
export const Background = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #283044cc;
    z-index: 900;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 14px;
    transition: opacity 0.35s, visibility 0.35s;
    visibility: visible;
    opacity: 1;
    &.hidden {
        visibility: hidden;
        opacity: 0;
    }
`;